import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const CREATE_COMPANY = gql`
mutation CreateCompany($input: CreateCompanyInput!) {
	company {
		create(input: $input) {
			code
			success
			message
		}
	}
}
`

export interface CreateCompanyResponse {
	company: {
		create: Def_MutationResponse
	}
}

export interface CreateCompanyArgs {
	input: CreateCompanyInput;
}

export interface CreateCompanyInput {
  domain: string
  name: string
  tags?: string[]
  city?: string
  street?: string
  phone?: string
  vat?: string
  email?: string
  legacy?: boolean
}